module.exports = __webpack_public_path__ + "static/media/background.96d42165.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/background.png
// module id = 207
// module chunks = 1